jQuery(function($) {

    upcomingEvents();
    mixedContentSlider();

    function upcomingEvents() {
        // upcoming events
        $('.fbyf-upcoming-events .tribe-list-widget').addClass('owl-carousel');
        $('.fbyf-upcoming-events .tribe-list-widget').owlCarousel({
            responsive: {
                0: { items: 1 },
                768: { items: 2 },
                992: { items: 3 }
            },
            margin: 16
        });
    }

    function mixedContentSlider() {
        var $slider  = $('.fbyf-mixed-content-slider_container');

        $slider.slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            infinite: true,
            speed: 1000,
            fade: true,
            cssEase: 'linear',
            slideToScroll: true
        });
    }

});
